module.exports = __webpack_public_path__ + "static/media/Bank.831a9eeb.png";